export const NOTICE_TYPE = {
  REGISTER: "REGISTER",
  SPECIAL_TIME: "SPECIAL_TIME",
  APP_NEW_VERSION: "VERSION",
};

export const NOTICE_PLATFORM = {
  APP: "APP",
  WEB: "WEB",
};

export const NOTICE_ACTION = {
  PUBLISH: "PUBLISH",
  UNPUBLISH: "UNPUBLISH",
  DELETE: "DELETE",
};
